'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _TransmuteCollection = require('./TransmuteCollection');

_TransmuteCollection.map.implement(Array, function (mapper, arr) {
  return arr.map(mapper);
});

_TransmuteCollection.map.implementInherited(_immutable.Iterable, function (mapper, iter) {
  return iter.map(mapper);
});

_TransmuteCollection.map.implement(Object, function (mapper, obj) {
  var result = {};
  var keys = Object.keys(obj);
  var len = keys.length;
  for (var i = 0; i < len; i++) {
    var key = keys[i];
    result[key] = mapper(obj[key], key, obj);
  }
  return result;
});

exports.default = _TransmuteCollection.map;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.9/internal/_map.js
// module id = 387
// module chunks = 0